(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["codex-chat-control"]) return;
  try {
    
  (() => {
    const chatTerms = [
      'chat',
      'inbox',
      'tidio',
      'crisp',
      'intercom',
      'gorgias',
      'zendesk',
      'tawk',
      'messenger',
      'whatsapp',
      'bot',
      'helpdesk',
      'customer'
    ];
    const hiddenNodes = new Set();
    let userAllowedChat = sessionStorage.getItem('codexAllowChat') === '1';

    const getDescriptor = (element) => {
      const values = [
        element.id,
        element.className,
        element.title,
        element.getAttribute('aria-label'),
        element.getAttribute('name'),
        element.getAttribute('src')
      ];
      return values.join(' ').toLowerCase();
    };

    const isChatElement = (element) => {
      const descriptor = getDescriptor(element);
      return chatTerms.some((term) => descriptor.includes(term));
    };

    const isBottomRight = (rect) => {
      return rect.right > window.innerWidth - 96 && rect.bottom > window.innerHeight - 96 && rect.left > window.innerWidth * 0.35;
    };

    const isExpanded = (rect) => {
      return rect.width > 170 && rect.height > 170;
    };

    const hideNode = (element) => {
      if (hiddenNodes.has(element)) return;
      element.dataset.codexChatSuppressed = 'true';
      element.style.setProperty('opacity', '0', 'important');
      element.style.setProperty('visibility', 'hidden', 'important');
      element.style.setProperty('pointer-events', 'none', 'important');
      hiddenNodes.add(element);
    };

    const releaseHiddenNodes = () => {
      hiddenNodes.forEach((element) => {
        if (!element.isConnected) return;
        element.style.removeProperty('opacity');
        element.style.removeProperty('visibility');
        element.style.removeProperty('pointer-events');
        delete element.dataset.codexChatSuppressed;
      });
      hiddenNodes.clear();
    };

    const nearestFixedAncestor = (element) => {
      let current = element;
      while (current && current !== document.body) {
        const position = window.getComputedStyle(current).position;
        if (position === 'fixed' || position === 'sticky') return current;
        current = current.parentElement;
      }
      return element;
    };

    const suppressAutoChat = () => {
      if (userAllowedChat) {
        releaseHiddenNodes();
        return;
      }

      document.querySelectorAll('iframe, [id], [class], [aria-label], [title]').forEach((element) => {
        if (!isChatElement(element)) return;

        const target = nearestFixedAncestor(element);
        const rect = target.getBoundingClientRect();
        if (!isBottomRight(rect)) return;
        if (!isExpanded(rect)) return;

        hideNode(target);
      });
    };

    const allowChatFromPointer = (event) => {
      if (event.clientX < window.innerWidth - 220 || event.clientY < window.innerHeight - 220) return;
      userAllowedChat = true;
      sessionStorage.setItem('codexAllowChat', '1');
      releaseHiddenNodes();
    };

    document.addEventListener('pointerdown', allowChatFromPointer, { capture: true, passive: true });
    window.addEventListener('load', suppressAutoChat);
    window.addEventListener('resize', suppressAutoChat);

    const observer = new MutationObserver(suppressAutoChat);
    observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

    suppressAutoChat();
    setTimeout(suppressAutoChat, 800);
    setTimeout(suppressAutoChat, 2200);
    setTimeout(suppressAutoChat, 5000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relife-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeRelifeHeroes = (root = document) => {
    root.querySelectorAll('[data-relife-hero]:not([data-relife-ready])').forEach((hero) => {
      hero.dataset.relifeReady = 'true';
      const slides = Array.from(hero.querySelectorAll('[data-relife-slide]'));
      if (slides.length < 2) return;

      const previousButton = hero.querySelector('[data-relife-previous]');
      const nextButton = hero.querySelector('[data-relife-next]');
      const toggleButton = hero.querySelector('[data-relife-toggle]');
      const toggleIcon = hero.querySelector('[data-relife-toggle-icon]');
      const currentLabel = hero.querySelector('[data-relife-current]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplayEnabled = hero.dataset.autoplay === 'true' && !reduceMotion;
      const speed = Number(hero.dataset.speed) || 7000;
      let currentIndex = 0;
      let timer;
      let userPaused = !autoplayEnabled;

      const render = () => {
        slides.forEach((slide, index) => {
          const isActive = index === currentIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });
        currentLabel.textContent = String(currentIndex + 1);
      };

      const stop = () => {
        window.clearInterval(timer);
      };

      const start = () => {
        stop();
        if (userPaused) return;
        timer = window.setInterval(() => {
          currentIndex = (currentIndex + 1) % slides.length;
          render();
        }, speed);
      };

      const updateToggle = () => {
        const label = userPaused ? toggleButton.dataset.playLabel : toggleButton.dataset.pauseLabel;
        toggleButton.setAttribute('aria-label', label);
        toggleIcon.textContent = userPaused ? '>' : '||';
      };

      previousButton.addEventListener('click', () => {
        currentIndex = (currentIndex - 1 + slides.length) % slides.length;
        render();
        start();
      });

      nextButton.addEventListener('click', () => {
        currentIndex = (currentIndex + 1) % slides.length;
        render();
        start();
      });

      toggleButton.addEventListener('click', () => {
        userPaused = !userPaused;
        updateToggle();
        start();
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);
      hero.addEventListener('focusin', stop);
      hero.addEventListener('focusout', (event) => {
        if (!hero.contains(event.relatedTarget)) start();
      });

      updateToggle();
      render();
      start();
    });
  };

  initializeRelifeHeroes();
  document.addEventListener('shopify:section:load', (event) => initializeRelifeHeroes(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["relife-whats-new"] && !Shopify.designMode) return;
  try {
    
  const initializeRelifeNewSections = (root = document) => {
    root.querySelectorAll('[data-relife-new]:not([data-relife-new-ready])').forEach((section) => {
      section.dataset.relifeNewReady = 'true';
      const rail = section.querySelector('[data-relife-new-rail]');
      const previous = section.querySelector('[data-relife-new-previous]');
      const next = section.querySelector('[data-relife-new-next]');
      if (!rail || !previous || !next) return;

      const scroll = (direction) => {
        const card = rail.querySelector('.relife-new__card');
        const distance = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8;
        rail.scrollBy({ left: distance * direction, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => scroll(-1));
      next.addEventListener('click', () => scroll(1));
    });
  };

  initializeRelifeNewSections();
  document.addEventListener('shopify:section:load', (event) => initializeRelifeNewSections(event.target));

  } catch(e) { console.error(e); }
})();
})();
